import React, { useState, useContext } from 'react';
import { useActor } from '@xstate/react';
import { GlobalStateContext } from '../../state/app/index';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const SnippetOverflowMenu = ({ snippetNoteId, section, isNoteOpen }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const globalServices = useContext(GlobalStateContext);
  const [appState, sendAppState] = useActor(globalServices.appState);
  const [, sendModalState] = useActor(globalServices.modalState);
  const { selectedAreaOfFocus, notes } = appState.context;

  const menuOpen = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const handleMoveToTrash = (event) => {
    event.stopPropagation();
    setAnchorEl(null);

    const { selected_stack: selectedStack = [] } = selectedAreaOfFocus;
    const noteIsCurrentlyOpen = selectedStack.length
      ? selectedStack.includes(snippetNoteId)
      : false;
    const activeNote = notes[snippetNoteId];
    const isTrash = section === 'trash';

    const callback = () => {
      sendAppState({
        type: 'trashAndCloseNote',
        data: {
          noteId: snippetNoteId,
          selectedAreaOfFocus,
          isNoteOpen: noteIsCurrentlyOpen,
        },
      });
      sendModalState({ type: 'closeModal' });
    };

    sendModalState({
      type: 'updateModal',
      data: {
        visible: true,
        title: isTrash
          ? 'Are you sure you want to delete your note?'
          : 'Are you sure you want to move your note to the trash?',
        sectionClassName: 'delate-note-modal',
        showCloseModal: false,
        content: (
          <div className="delete-note-modal-body">
            <div className="note-title">
              <span>{activeNote?.note_title}</span>
            </div>
          </div>
        ),
        primaryButton: {
          title: isTrash ? 'Delete' : 'Trash',
          callback,
        },
        secondaryButton: {
          title: isTrash ? "Don't Delete" : "Don't Trash",
          callback: () => sendModalState({ type: 'closeModal' }),
        },
      },
    });
  };

  const handleGetInfo = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
    sendAppState({ type: 'SelectTab', tabName: 'info' });
  };

  const handleCloseNote = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
    sendAppState({
      type: 'closeAndSelectNextNote',
      data: { noteId: snippetNoteId, isNoteOpen: true },
    });
  };

  return (
    <div
      className="snippet-overflow-menu-container"
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <button
        className="snippet-overflow-menu-btn"
        type="button"
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={handleOpenMenu}
        aria-label="Note options"
        aria-haspopup="true"
        aria-expanded={menuOpen}
      >
        <MoreVertIcon fontSize="small" />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleCloseMenu}
        onClick={(e) => e.stopPropagation()}
        MenuListProps={{ dense: true }}
        PaperProps={{
          sx: {
            backgroundColor: '#252526',
            color: '#cccccc',
            border: '1px solid #3c3c3c',
            minWidth: 180,
            boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
          },
        }}
      >
        <MenuItem
          onClick={handleMoveToTrash}
          sx={{
            fontSize: '13px',
            color: '#cccccc',
            '&:hover': { backgroundColor: '#37373d' },
          }}
        >
          <ListItemIcon sx={{ minWidth: '28px !important', color: 'inherit' }}>
            <DeleteOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '13px' }}>
            {section === 'trash' ? 'Delete permanently' : 'Move to trash'}
          </ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleGetInfo}
          sx={{
            fontSize: '13px',
            color: '#cccccc',
            '&:hover': { backgroundColor: '#37373d' },
          }}
        >
          <ListItemIcon sx={{ minWidth: '28px !important', color: 'inherit' }}>
            <InfoOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '13px' }}>
            Get info
          </ListItemText>
        </MenuItem>
        {isNoteOpen && (
          <MenuItem
            onClick={handleCloseNote}
            sx={{
              fontSize: '13px',
              color: '#cccccc',
              '&:hover': { backgroundColor: '#37373d' },
            }}
          >
            <ListItemIcon sx={{ minWidth: '28px !important', color: 'inherit' }}>
              <CloseIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ fontSize: '13px' }}>
              Close
            </ListItemText>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default SnippetOverflowMenu;
